import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage';

import productDomain from '../utils/productDomain';
import createRootReducer from './ducks';
import history from '../routes/history';
import rootSaga from './sagas';
import { INITIAL_STATE_OBJ as productDefaultState } from './ducks/product';
import { INITIAL_STATE as authDefaultState } from './ducks/auth';

export default function configureStore(preloadedState) {
  const sagaMiddleware = createSagaMiddleware();

  const transformPersistedState = createTransform(
    inboundState => ({ ...inboundState }),
    (outboundState, key) => {
      let productState;
      switch (key) {
        case 'auth':
          return {
            ...outboundState,
            isAuthenticated: false,
            loading: {
              ...authDefaultState.loading,
            },
          };
        case 'product':
          if (outboundState.product !== productDomain) {
            return productDefaultState;
          }
          productState = outboundState.error
            ? { ...productDefaultState, error: outboundState.error }
            : outboundState;
          return productState;
        default:
          return outboundState;
      }
    },
  );

  const persistConfig = {
    key: '@app-students-190520',
    storage,
    whitelist: ['auth', 'product'],
    serialize: true,
    debug: true,
    transforms: [transformPersistedState],
  };
  const persistedReducer = persistReducer(
    persistConfig,
    createRootReducer(history),
  );

  const store = createStore(
    persistedReducer,
    preloadedState,
    composeWithDevTools(
      /* logger must be the last middleware in chain to log actions */
      applyMiddleware(routerMiddleware(history), sagaMiddleware),
    ),
  );
  sagaMiddleware.run(rootSaga);

  const persistor = persistStore(store);
  return { store, persistor };
}
